import {
    DialogContent,
    DialogTitle,
    IconButton,
    ListItem,
    ListItemText,
    makeStyles,
} from "@material-ui/core";
import Close from "@material-ui/icons/Close";
import { Dialog } from "@mui/material";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles({
    dialogBox: {
        margin: "6px 200px 0px 200px",
    },
});

function SubFileSelectDialog({
    formOpen,
    optionList,
    onDownload,
    reset,
    handleOnClose,
}) {
    const classes = useStyles();
    const { t, i18n } = useTranslation();

    return (
        <>
            <Dialog
                open={formOpen}
                maxWidth="xs"
                fullWidth={true}
                onClose={handleOnClose}
            >
                <DialogTitle id="sub-file-select-dialog">
                    <div
                        style={{
                            justifyContent: "space-between",
                            display: "flex",
                        }}
                    >
                        <div style={{ paddingTop: "1rem" }}>
                            {t(`common.selectReportType`)}
                        </div>
                        <div>
                            <IconButton
                                aria-label="cancel"
                                onClick={handleOnClose}
                                // style={{ marginLeft: "14rem" }}
                            >
                                <Close />
                            </IconButton>
                        </div>
                    </div>
                </DialogTitle>
                <DialogContent style={{ paddingBottom: "2rem" }}>
                    {Object.entries(optionList).map(([key, value]) => {
                        return (
                            <ListItem
                                key={key}
                                button
                                onClick={() => {
                                    onDownload(key);
                                    reset();
                                }}
                            >
                                <ListItemText>{value}</ListItemText>
                            </ListItem>
                        );
                    })}
                </DialogContent>
            </Dialog>
        </>
    );
}

export default SubFileSelectDialog;
